import styled from 'styled-components'

const EmptyListTitleUi = styled.span`
  font-weight: 700;
  font-size: 21px;
`

export default EmptyListTitleUi
